<template>
  <div class="container">
    <p>{{ t('determineWaterUsageAndCost') }}</p>
    <EquationBlock
      :equations="equations"
    />
    <hr />
    <div class="row">
      <div class="col-sm">
        <FixedUnitInput
          :input-label="t('waterRatePerPlant')"
          v-model.number="gphPerPlant"
          :unit="t('gph')"
        />
        <FixedUnitInput
          :input-label="t('hoursOnPerDay')"
          v-model.number="hoursOnPerDay"
          :unit="t('hours')"
        />
        <FixedUnitInput
          :input-label="t('plantCount')"
          v-model.number="plantCount"
          :unit="t('plants')"
        />
        <FixedUnitInput
          :input-label="t('waterCost')"
          v-model.number="waterCost"
          :unit="t('dollarsPerCubicFoot')"
        />
      </div>
      <div class="col-sm">
        <FixedUnitOutput
          :output-label="t('waterUsedPerDay')"
          :number="gallonsPerDay"
          :unit="t('gallonsPerDay')"
        />
        <FixedUnitOutput
          :output-label="t('costPerDay')"
          :prefix="t('dollarSign')"
          :number="costPerDay"
        />
        <FixedUnitOutput
          :output-label="t('waterUsedPerMonth')"
          :number="gallonsPerMonth"
          :unit="t('gallonsPerMonth')"
        />
        <FixedUnitOutput
          :output-label="t('costPerMonth')"
          :prefix="t('dollarSign')"
          :number="costPerMonth"
        />
        <i>{{ t('monthAssumption') }}</i>
      </div>
    </div>
  </div>
</template>

  
  <script>
  import { ref, computed , reactive } from 'vue';
  import FixedUnitInput from '../inputs/FixedUnitInput.vue';
  import FixedUnitOutput from '../inputs/FixedUnitOutput.vue';
  import EquationBlock from '../inputs/EquationBlock.vue';
  import { defaultRound, round } from '../../utils/math';
  import { useI18n } from 'vue-i18n';
  
  export default {
    components: {
      FixedUnitInput,
      FixedUnitOutput,
      EquationBlock,
    },
    setup() {
      const gphPerPlant = ref(2);
      const hoursOnPerDay = ref(1);
      const waterCost = ref(0.13);
      const plantCount = ref(10);

      const { t, tm } = useI18n();

      // Create a reactive object with a function
      const translations = reactive({
        t: (key) => t(key)
      })

      const equations = computed(() => {
          return tm('weightConvCalcEquations');
      });

      const gallonsPerDay = computed(() => {
        return defaultRound(gphPerPlant.value * hoursOnPerDay.value * plantCount.value);
      });
  
      const cubicFeetPerDay = computed(() => {
        return gallonsPerDay.value * 0.133680556;
      });
  
      const costPerDay = computed(() => {
        return round(cubicFeetPerDay.value * waterCost.value, 2);
      });
  
      const gallonsPerMonth = computed(() => {
        return defaultRound(gallonsPerDay.value * 31);
      });
  
      const costPerMonth = computed(() => {
        return round(costPerDay.value * 31, 2);
      });
  
      return {
        gphPerPlant,
        hoursOnPerDay,
        waterCost,
        plantCount,
        gallonsPerDay,
        costPerDay,
        gallonsPerMonth,
        costPerMonth,
        equations,
        t: translations.t
      };
    },
  };
  </script>
  